import { ReactNode } from 'react';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Modal } from '@/components/ui/daisy';
import { useModalDialog } from '@/components/ui/daisy/modal/hooks';
import useDeferredUnmount from '@/data/hook/shared/useDeferredUnmount';

const EXIT_ANIMATION_MS = 200;

type QuestionsPreviewModalProps = {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
};

export default function QuestionsPreviewModal({
  visible,
  onClose,
  children,
}: QuestionsPreviewModalProps) {
  const shouldRenderContent = useDeferredUnmount(visible, EXIT_ANIMATION_MS);
  const { ref } = useModalDialog(visible, onClose);

  return (
    <Modal ref={ref} className="modal-middle">
      <Modal.Box className="w-11/12 max-w-xl pt-12">
        <ConditionalRenderer condition={shouldRenderContent}>
          {children}
        </ConditionalRenderer>
        <Modal.Close />
      </Modal.Box>
      <Modal.Backdrop />
    </Modal>
  );
}
